export const BottomSheetExperiment = Object.freeze({
  'Old': 'old',
  'New': 'new',
})
